import React, { FC } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { color, px } from "Configs/theme";
import { getColorRgbaFromHex } from "Helpers/ColorHelper";

interface Props {}

const ContentView: FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {props.children || <Box className={classes.placeholder} />}
    </Box>
  );
};

export default ContentView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flex: 1,
  },
  placeholder: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: px.s,
    backgroundColor: getColorRgbaFromHex(color.placeholder, 0.5),
    margin: px.m,
    marginLeft: px.none,
  },
});
